import {
  COCO_LINK_TYPE_OPTIONS,
  SOURCE_SYSYTEM_OPTIONS,
} from "../../../../utils/constants";
import FormField from "../../../FormField";
import { useIntl } from "react-intl";

const SelectLinkDetailsStep = ({
  identitiesByType,
  emailOptions,
  availableSourceSystems,
  linkData,
  setLinkData,
  hasSubmitted,
}) => {
  const intl = useIntl();

  // Normalize type: vault and vault_id are the same
  const normalizeType = (type) => {
    if (!type) return "";
    const lower = type.toLowerCase();
    return lower === "vault" ? "vault_id" : lower;
  };

  // Build email options for Email1 and Email2
  const emailOptionsForSelect =
    emailOptions?.map((email) => ({
      ...email,
      label: email.value,
      value: email.value,
    })) || [];

  // Build source system options: show available systems, always include static options
  const sourceSystemOptions = SOURCE_SYSYTEM_OPTIONS.map((option) => ({
    ...option,
    disabled:
      availableSourceSystems.length > 0 &&
      !availableSourceSystems.includes(option.value),
  }));

  // Build customer ID options based on selected source system
  const selectedSourceSystem =
    linkData?.sourceSystem || availableSourceSystems[0] || "veeva";
  const normalizedSysType = normalizeType(selectedSourceSystem);
  const customerOptions =
    identitiesByType[normalizedSysType]?.map((item) => ({
      ...item,
      label: item.value,
      value: item.value,
    })) || [];

  // Ensure currently selected values are in the options (fallback)
  const addFallbackOption = (currentValue, options) => {
    if (currentValue && !options.some((opt) => opt.value === currentValue)) {
      options.push({
        label: currentValue,
        value: currentValue,
      });
    }
    return options;
  };

  const finalSourceSystemOptions = addFallbackOption(
    linkData?.sourceSystem,
    sourceSystemOptions,
  );
  const finalCustomerOptions = addFallbackOption(
    linkData?.customerId,
    customerOptions,
  );

  // Handle source system change: auto-select first customer ID for the new system
  const handleChange = async (e) => {
    const { name, value: newValue } = e.target;

    const newData = {
      ...linkData,
      [name]: newValue,
    };

    // When source system changes, auto-populate first available customer ID
    if (name === "sourceSystem") {
      const normalizedNewType = normalizeType(newValue);
      const newCustomerOptions = identitiesByType[normalizedNewType] || [];
      newData.customerId = newCustomerOptions[0]?.value || "";
    }

    setLinkData(newData);
  };

  return (
    <div className="row">
      <h5 className="fs-6">Step 2: Select Link Details</h5>
      <div className="row" style={{ marginBottom: 10 }}>
        {/* Email 1 */}
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              value={linkData?.emailOne}
              name="emailOne"
              type="select"
              options={emailOptionsForSelect}
              id="Email1"
              label={intl.formatMessage({
                id: "label.Email1",
                defaultMessage: "Email 1",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.Email1",
                defaultMessage: "Email 1",
              })}
              handleChange={handleChange}
            />
          </div>
        </div>

        {/* Email 2 */}
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              value={linkData?.emailTwo}
              name="emailTwo"
              type="select"
              options={emailOptionsForSelect}
              id="Email2"
              label={intl.formatMessage({
                id: "label.Email2",
                defaultMessage: "Email 2",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.Email2",
                defaultMessage: "Email 2",
              })}
              handleChange={handleChange}
            />
          </div>
        </div>

        {/* Source System */}
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              formType="create"
              value={linkData?.sourceSystem}
              name="sourceSystem"
              type="select"
              options={finalSourceSystemOptions}
              id="sourceSystem"
              label={intl.formatMessage({
                id: "label.sourceSystem",
                defaultMessage: "Source System",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.sourceSystem",
                defaultMessage: "Source System",
              })}
              handleChange={handleChange}
              rules={{
                required: true,
                hasSubmitted: hasSubmitted,
              }}
            />
          </div>
        </div>
      </div>

      <div className="row" style={{ marginBottom: 10 }}>
        {/* Customer ID */}
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              formType="create"
              value={linkData?.customerId}
              name="customerId"
              type="select"
              options={finalCustomerOptions}
              id="customerId"
              label={intl.formatMessage({
                id: "label.customerId",
                defaultMessage: "Customer ID",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.customerId",
                defaultMessage: "Customer ID",
              })}
              handleChange={handleChange}
              rules={{
                required: true,
                hasSubmitted: hasSubmitted,
              }}
            />
          </div>
        </div>

        {/* COCO Link Type */}
        <div className="col-md-8">
          <div className="form-group">
            <FormField
              formType="create"
              defaultValue={COCO_LINK_TYPE_OPTIONS[0]}
              value={linkData?.cocoLinktype}
              name="cocoLinktype"
              type="select"
              options={COCO_LINK_TYPE_OPTIONS}
              id="cocoLinktype"
              label={intl.formatMessage({
                id: "label.cocoLinktype",
                defaultMessage: "COCO Link Type",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.cocoLinktype",
                defaultMessage: "COCO Link Type",
              })}
              handleChange={handleChange}
              rules={{
                required: true,
                hasSubmitted: hasSubmitted,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectLinkDetailsStep;
